<template>
  <section :class="sectionClass" v-if="context.item.modulbildergalerieueberschrift">
    <div class="container">
      <h2 class="section-title images__title">
        <span class="headline" v-html="context.item.modulbildergalerieueberschrift"></span>
      </h2>

      <ul class="grid-auto grid-auto-4c images__list">
        <template v-for="i in 8" :key="i">
          <li class="grid-c images__list-item" v-if="getField('modulbildergaleriebild' + i).url">
            <img
              class="images__image"
              :src="getField('modulbildergaleriebild' + i).url"
              :alt="getField('modulbildergaleriebild' + i).alt"
            />
          </li>
        </template>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModulBildergalerie',
  props: {
    context: {
      type: Object,
    },
  },
  computed: {
    sectionClass: function () {
      if (this.context.item.modulbildergaleriestyle != '')
        return (
          'outer images images--4c section-styling-' + this.context.item.modulbildergaleriestyle
        );
      return 'outer images images--4c section-styling-0';
    },
  },
  methods: {
    getField(field) {
      const fullPath = `${field}`;
      return this.context.item[fullPath] || '';
    },
  },
};
</script>
